import React from "react";
import {Box} from "@mui/material";

export default function GVarLogo({ height = 32, sx = {} }) {
  return (
    <Box
      component="img"
      src="/gVar_v9.png"
      alt="G-VaR"
      sx={{ height, width: "auto", display: "block", ...sx }}
    />
  );
}
